export function innerWidth(el) {
  if (el.children.length === 0) {
    return el.offsetWidth;
  }

  return Array.from(el.children).reduce((width, element) => {
    return width + element.offsetWidth;
  }, 0);
}
